export const enum FileType {
  IMAGE = 'image',
  PDF = 'pdf'
}
